import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/ramana-steel-logo1.png';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/updatedteam1.jpeg';
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import TeamMain from './TeamMain';
import SEOHelmet from '../../components/SEO/SEOHelmet';


// Breadcrumbs Background Image

const Team = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <React.Fragment>
            <SEOHelmet 
                title="Our Team | Ramana Steels Experts"
                description="Meet the expert team behind Ramana Steels. Experienced professionals dedicated to delivering innovative scrap processing solutions."
                keywords="team, experts, professionals, ramana steels staff, about team"
                canonicalUrl="https://ramanasteels.com/team"
            />
            <Header
                navImg={navImg1}
                parentMenu='team'
                activeMenu="/team"
            />
            {/* SiteBreadcrumb */}
            <SiteBreadcrumb
                pageTitle="Our Team"
                pageName="Our Team"
                breadcrumbsImg={bannerbg}
            />
            {/* SiteBreadcrumb */}
            <TeamMain />
            {/*cta-section */}
            {/* <CtaTwo /> */}
            {/*cta-section end */}
            <BackToTop scroll={isVisible} />
            <FooterTwo />
        </React.Fragment>
    );
}

export default Team;